import axios from 'axios'
import * as types from './types'

export default {
  [types.SEARCH_COMPETENCES]: ({ commit }, payload) => {
    const resource = `/api/contracts/competences/search?page=${payload.currentPage}`
    const params = { ...payload }
    delete params.currentPage

    return axios.post(resource, params)
      .then(resp => {
        commit(types.MUTATE_COMPETENCES_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.GET_CURRENT_COMPETENCE]: ({ commit }) => axios
    .get('/api/contracts/competences/current')
    .then(resp => {
      commit(types.MUTATE_CURRENT_COMPETENCE, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_EXPECTED_CLOSING_DATE]: (context, payload) => axios
    .get('/api/contracts/competences/expected_date', { params: { competence: payload.competence } })
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
  [types.SEARCH_CLOSING_EXCEPTIONS]: ({ commit }, payload) => {
    const resource = `/api/contracts/closing_exceptions/search?page=${payload.currentPage}`
    const params = { ...payload }
    delete params.currentPage

    return axios.post(resource, params)
      .then(resp => {
        commit(types.MUTATE_CLOSING_EXCEPTIONS_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.EXPORT_CLOSING_EXCEPTIONS]: (context, payload) => axios
    .post('/api/contracts/closing_exceptions/export', payload, { responseType: 'blob' })
    .then(resp => {
      const fileURL = window.URL.createObjectURL(new Blob([resp.data]))
      const fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', 'futuro_alteracoes_extraordinarias.xlsx')
      document.body.appendChild(fileLink)
      fileLink.click()
      document.body.removeChild(fileLink)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  [types.GET_CLOSING_EXCEPTION_CATEGORIES]: ({ commit }) => axios
    .get('/api/contracts/closing_exceptions/categories')
    .then(resp => {
      commit(types.MUTATE_CLOSING_EXCEPTION_CATEGORIES, resp.data)
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  // Passo 1 da alteração extraordinária: registra a justificativa e devolve o
  // `exception_id` que a mutação real (passo 2) precisa carregar.
  [types.SAVE_CLOSING_EXCEPTION]: (context, payload) => axios
    .post('/api/contracts/closing_exceptions', payload)
    .then(resp => Promise.resolve(resp))
    .catch(err => Promise.reject(err)),
}
